import { useFrameScrolled } from "@ui/components/Frame/FrameContext";
import { tv } from "@ui/lib/tv";

// Top-edge mirror of SheetChrome's `surfaceFooterGradient` — same stops and timing, pointed down.
const topBarScrollShadow = tv({
  base: "pointer-events-none absolute right-0 -bottom-3.5 left-0 h-3.5 bg-[linear-gradient(to_bottom,rgba(74,74,74,0.14)_0%,rgba(74,74,74,0.07)_9.6%,rgba(74,74,74,0.03)_41.8%,rgba(74,74,74,0)_100%)] transition-opacity duration-200",
  defaultVariants: {
    visible: false,
  },
  variants: {
    visible: {
      false: "opacity-0",
      true: "opacity-100",
    },
  },
});

export interface TopBarScrollShadowProps {
  /** Pins the gradient on or off instead of following the Frame's scroll state — for surfaces the
   *  Frame's scroller can never move (a full-bleed map whose sheet owns the travel), where the
   *  scroll state would never change. */
  visible?: boolean;
  className?: string;
}

/** Soft gradient below a top bar, faded in only once content has scrolled under it. Reads the
 *  Frame's scroll state, so it works inside the `Frame.TopBar` slot with no prop drilling. */
export function TopBarScrollShadow({ visible, className }: TopBarScrollShadowProps) {
  const isScrolled = useFrameScrolled();

  return <div aria-hidden className={topBarScrollShadow({ visible: visible ?? isScrolled, className })} />;
}
